import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HeradexiaWaitlist from './pages/HeradexiaWaitlist';
import HowItWorks from './pages/HowItWorks'; // Create this file separately
import UseDemo from './pages/UseDemo'; // Create this file separately
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HeradexiaWaitlist />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/use-demo" element={<UseDemo />} />
    </Routes>
  );
}




